<template>
  <div class="messageBox">
    <PersonAlertVue />
    <div ref="messageBox" class="message">
      <template v-if="msgList.contact && (currentSession.id || currentSession.id === 0)">
        <!-- 顶部加载更多的loading -->
        <!-- 判断条件:1. 是否在loading中 2.消息是否大于10条 3. 是否刚刚切换用户 -->
        <!-- <img
          v-if="
            isShowLoading &&
              !isHandlerOtherUser &&
              msgList.contact &&
              currentSession.id &&
              msgList.contact[currentSession.id] &&
              msgList.contact[currentSession.id].length &&
              msgList.contact[currentSession.id].length >= 10
          "
          :src="IMAGE_LOADING + '?x-oss-process=image/resize,m_fixed,h_44,w_44'"
          class="loading"
          alt="loading"
          title="loading"
        > -->

        <!-- 加载图标 -->
        <Loading :isShowLoading="isShowLoading" :isGetAllData="isGetAllData" />
        <!-- 加载图标 -->

        <div
          v-for="(msg, index) in msgList.contact[currentSession.id]"
          :key="'msg' + index + currentSession.id"
          class="messageItem"
        >
          <template v-if="!(msg.contentsType === 'TEXT' && !msg.data)">
            <!-- 聊天的时间 -->
            <p>
              {{ msg.time | momentTime }}
            </p>
            <br />

            <!-- 如果消息是撤回状态 -->
            <p v-if="msg.status === 'recall'">
              {{
                msg.from == currentUser.id || msg.from == IMLoginInfo.ip
                  ? $t('我撤回了一条消息')
                  : $t('对方撤回了一条消息')
              }}
            </p>

            <div
              v-else-if="msg.ext || msg.user"
              class="msg"
              :class="
                msg.from == currentUser.id || msg.from == IMLoginInfo.ip || msg.from == IMLoginInfo.nickname
                  ? 'self'
                  : ''
              "
            >
              <!-- 用户头像 -->
              <img
                v-lazy="
                  (msg.from == currentUser.id || msg.from == IMLoginInfo.ip || msg.from == IMLoginInfo.nickname
                    ? selfAvatar
                    : otherSideAvater) || DEFAULTS_AVATAR
                "
                class="avatar"
                :src="
                  (msg.from == currentUser.id || msg.from == IMLoginInfo.ip || msg.from == IMLoginInfo.nickname
                    ? selfAvatar
                    : otherSideAvater) || DEFAULTS_AVATAR
                "
              />

              <!-- 具体的消息 -->
              <div
                :style="`display: flex;flex-direction: column;align-items:${
                  msg.from == currentUser.id || msg.from == IMLoginInfo.ip || msg.from == IMLoginInfo.nickname
                    ? 'flex-end'
                    : 'flex-start'
                }`"
              >
                <!-- 自己的信息 -->
                <div
                  v-if="msg.from == currentUser.id || msg.from == IMLoginInfo.ip || msg.from == IMLoginInfo.nickname"
                  style="text-align: right; font-weight: bold; margin-right: 5px; max-width: 450px"
                >
                  <!-- 如果自己是游客 -->
                  <template v-if="msg.from == IMLoginInfo.ip || msg.from == IMLoginInfo.nickname">
                    {{ `${$t('游客')}` }}
                    <template v-if="IMLoginInfo.ip || IMLoginInfo.ipLocation">
                      {{ `(${IMLoginInfo.ip} ${IMLoginInfo.ipLocation})` }}
                    </template>
                  </template>

                  <template v-else-if="$store.state.userInfo.company && $store.state.userInfo.company.companyName">
                    ({{ $store.state.userInfo.company.companyName }})
                    {{ $store.state.userInfo.memberCard.contact }}
                  </template>

                  <template v-else>
                    ({{ $store.state.userInfo.phone
                    }}{{ $store.state.userInfo.phone && $store.state.userInfo.email ? ' / ' : ''
                    }}{{ $store.state.userInfo.email }})
                    {{ $store.state.userInfo.memberCard.contact }}
                  </template>
                </div>

                <!-- 对方的头部 -->
                <OtherUserHeader v-else :otherUserInfo="otherUserInfo" :msg="msg" />

                <MsgContBox :msg="msg" />
                <transformMsg v-if="msg.transInfo" :transInfo="msg.transInfo" />

                <!-- 洽谈框下面的状态栏 -->
                <div
                  v-if="msg.from !== currentUser.id && msg.from !== IMLoginInfo.ip && msg.from !== IMLoginInfo.nickname"
                  class="btnStatus"
                  style="margin-left: auto"
                >
                  <p v-if="msg.ext && msg.ext.moduleId === '23'">
                    {{ $t('系统自动发送') }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'

import Loading from './msgItem/loading.vue'
import OtherUserHeader from './msgItem/otherHeader.vue'
import PersonAlertVue from './msgItem/personAlert.vue'
import MsgContBox from './msgItem/msgContBox'
import TransformMsg from './msgItem/transformMsg.vue'

import { DEFAULTS_AVATAR, IMAGE_LOADING } from '@/const/image'

import { downloadWithBlob, getfilesize, getIconToFileName } from '@/utils/files'
import { getChatHistory, removeUnread } from '@/api/pushSend'

export default {
  name: 'ChatMessage',
  components: {
    Loading,
    OtherUserHeader,
    PersonAlertVue,
    MsgContBox,
    TransformMsg,
  },
  filters: {
    getfilesize,
    getIconToFileName,
    momentTime(value) {
      if (!value) {
        return ''
      }
      return moment.unix(value / 1000).format('YYYY/MM/DD HH:mm:ss')
    },
  },
  data() {
    return {
      DEFAULTS_AVATAR,
      IMAGE_LOADING,
      isShowLoading: false,
      isScrollEventIng: false,
      // 更新数据前的滚动高度
      oldScrollHeight: 0,
      mediaCont: {},
      // 鼠标hover中的消息数据
      hoverMsgData: undefined,
      // 是否正在切换用户获取数据中
      isHandlerOtherUser: false,
      typeComparisonTable: {
        txt: 'TEXT',
        img: 'IMAGE',
        loc: 'LOCATION',
        audio: 'VOICE',
        video: 'VIDEO',
        file: 'FILE',
        product: '',
        card: '',
      },
      oldHistoryCurrent: 1,
      // 是否获取全部数据
      isGetAllData: false,
      oldHistoryMsgEndTime: moment().format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapGetters({
      msgList: 'chat/msgList',
      isChatModelShow: 'chat/isChatModelShow',
      // 被洽谈角色信息
      currentSession: 'chat/currentSession',
      // 当前登录的用户信息
      currentUser: 'chat/currentUser',
      userInfo: 'userInfo',
      // 自己如果是游客的信息
      IMLoginInfo: 'chat/IMLoginInfo',
      otherUserInfo: 'chat/otherUserInfo',
      msgCenterList: 'chat/msgCenterList',
      notificationsMsgList: 'chat/notificationsMsgList',
      modalMsgList: 'chat/modalMsgList',
    }),
    // 自己的头像
    selfAvatar() {
      const userInfo = this.$store.state.userInfo
      return (
        (userInfo.company && userInfo.company.logo) ||
        userInfo.avatar ||
        (userInfo.memberCard && userInfo.memberCard.cardAvatar)
      )
    },
    // 对方的头像
    otherSideAvater() {
      console.log('this.otherUserInfo', this.otherUserInfo)
      return this.otherUserInfo.cardAvatar || this.otherUserInfo.memberAvatar
    },
    nowContant() {
      return this.msgList.contact[this.currentSession.id]
    },
  },
  watch: {
    // 如果切换了用户, 消息自动滚动到最下面
    otherUserInfo: {
      handler(val, oldval) {
        this.isHandlerOtherUser = true

        this.oldHistoryMsgEndTime = moment().format('YYYY-MM-DD')

        // 清空未读消息, 避免重复发送短信
        removeUnread({
          from: this.otherUserInfo.memunicode || this.otherUserInfo.memUnicode || this.otherUserInfo.huanxinId,
          to: this.userInfo.huanxinId || this.userInfo.memunicode,
        })

        this.$nextTick(() => {
          setTimeout(() => {
            const msg = new this.$WebIM.message('channel', this.$WebIM.conn.getUniqueId())

            msg.set({
              to: this.otherUserInfo.memunicode || this.otherUserInfo.memUnicode || this.otherUserInfo.huanxinId, // 接收消息对象（用户id）
              success(data) {
                // 发送整个会话已读
                console.log('发送整个会话已读', data)
              },
              fail(data) {
                console.log('发送整个会话已读err', data)
              },
            })
            this.$WebIM.conn.send(msg.body)

            this.isHandlerOtherUser = false
            if (this.$refs.messageBox) {
              this.oldScrollHeight = this.$refs.messageBox.scrollHeight
              this.$refs.messageBox.scrollTop = this.$refs.messageBox.scrollHeight
            }

            this.setAudioUrl()
          }, 2000)
        })
      },
      deep: true,
      immediate: true,
    },
    // 页面切换时相应
    nowContant: {
      handler: debounce(
        function (val, oldVal) {
          const that = this

          if (that.$refs.messageBox && that.$refs.messageBox.scrollHeight) {
            console.log('msgList.contact[currentSession.id]', val, oldVal)
            if (!val || !oldVal || !val[0] || !oldVal[0]) {
              return
            }

            if (String(val[0].id) !== String(oldVal[0].id)) {
              // 如果是到顶部, 且获取新消息
              console.log(
                '如果是到顶部, 且获取新消息',
                that.$refs.messageBox.scrollTop,
                that.$refs.messageBox.scrollHeight,
                that.oldScrollHeight,
              )

              that.$nextTick(() => {
                that.$refs.messageBox.scrollTop = that.$refs.messageBox.scrollHeight - that.oldScrollHeight

                that.oldScrollHeight = that.$refs.messageBox.scrollHeight
              })
            } else {
              console.log('如果是自己或对方发送了新消息', val, oldVal)

              this.$nextTick(() => {
                that.oldScrollHeight = that.$refs.messageBox.scrollTop = that.$refs.messageBox.scrollHeight || 0
                that.setAudioUrl()
              })
            }
          }
        },
        100,
        {
          leading: true,
          trailing: true,
        },
      ),
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initMsg()
  },
  unmounted() {
    try {
      this.$refs.messageBox && this.$refs.messageBox.removeEventListener('scroll', this.scrollEvent)
    } catch (err) {
      console.log('err', err)
    }
  },
  methods: {
    ...mapActions({
      updateMessageFormList: 'chat/updateMessageFormList',
    }),
    downloadWithBlob,

    // 初始化消息组件, 消息列表滚动到最下面
    initMsg() {
      this.$nextTick(() => {
        if (this.$refs.messageBox && this.$refs.messageBox.scrollHeight) {
          this.$refs.messageBox.scrollTop = this.$refs.messageBox.scrollHeight
          this.oldScrollHeight = this.$refs.messageBox.scrollHeight
          setTimeout(() => {
            this.setAudioUrl()
            this.$refs.messageBox && this.$refs.messageBox.addEventListener('scroll', this.scrollEvent)
          }, 2000)
        }
      })
    },
    // 音频下载
    downAudio(url, index) {
      const that = this
      const options = {
        url,
        headers: { Accept: 'audio/mp3' },
        onFileDownloadComplete(response) {
          const objectUrl = that.$WebIM.utils.parseDownloadResponse.call(that.$WebIM.conn, response)
          that.mediaCont[index] = objectUrl
          that.$forceUpdate()
        },
        onFileDownloadError() {
          console.log('音频下载失败')
        },
      }

      this.$WebIM.utils.download.call(this.$WebIM.conn, options)
    },
    // TODO 性能优化
    setAudioUrl() {
      if (this.currentSession && this?.msgList?.contact[this.currentSession.id]) {
        this.msgList.contact[this.currentSession.id].map((item, index) => {
          // 如果是音频, 且之前没有执行过
          if (item.contentsType === 'VOICE' && !this.mediaCont[index]) {
            this.downAudio(item.url, index)
          }
        })
      }
    },
    // 页面滚动
    scrollEvent: throttle(function () {
      const that = this
      // 如果还没加载完全, 或者还在切换用户中, 不执行获取更多消息
      if (!that.$refs.messageBox || that.isHandlerOtherUser) {
        return
      }
      console.log('页面滚动', that.$refs.messageBox.scrollTop)
      if (that.$refs.messageBox.scrollTop === 0) {
        that.isScrollEventIng = true
        // 加载更多
        console.log('加载更多')
        try {
          if (!that.otherUserInfo) {
            that.isScrollEventIng = false
            return
          }

          // 如果所有消息都获取了, 则不执行
          if (!that.isGetAllData) {
            that.getHistoryMessages()
          }
        } catch (err) {
          console.log('err_getHistoryMessages', err)
        }
      }
    }, 1000),
    /**
     * 获取对话历史消息
     * @param {Object} options
     * @param {String} options.queue   - 对方用户id（如果用户id内含有大写字母请改成小写字母）/群组id/聊天室id
     * @param {String} options.count   - 每次拉取条数
     * @param {Boolean} options.isGroup - 是否是群聊,默认为false
     * @param {Function} options.success
     * @param {Function} options.fail
     */
    getHistoryMessages() {
      console.log('获取对话历史消息 getHistoryMessages')
      const that = this
      that.isShowLoading = true

      console.log('queue', that.otherUserInfo.huanxinId, that.otherUserInfo.mchMemberHuanxinId)

      this.$WebIM.conn.fetchHistoryMessages({
        queue: that.otherUserInfo.huanxinId || that.otherUserInfo.mchMemberHuanxinId,
        isGroup: false,
        count: 10,
        success(res) {
          try {
            that.isScrollEventIng = false
            console.log('获取历史消息成功', res)
            that.$store.commit('chat/ADD_HISTORY_MESSAGE', res)

            if (that?.msgList?.contact[that.currentSession?.id]?.time) {
              this.oldHistoryMsgEndTime = moment(Number(that?.msgList?.contact[that.currentSession?.id]?.time)).format(
                'YYYY-MM-DD',
              )
            }

            // 如果没获取新的消息, 获取旧的消息小于10条, 执行获取自己服务器消息的接口
            if (res.length === 0 || that?.msgList?.contact[that.currentSession?.id]?.length < 10) {
              that.getOldHistoryMessage(that)
            } else {
              that.isShowLoading = false
            }
          } catch (err) {
            console.log('err', err)
          }
        },
        fail(e) {
          that.isScrollEventIng = false
          that.isShowLoading = false
          console.log('fetchHistoryMessages_fail', e)
          // 失败原因:
          // e.type === '603' 被禁言
          // e.type === '605' 群组不存在
          // e.type === '602' 不在群组或聊天室中
          // e.type === '504' 撤回消息时超出撤回时间
          // e.type === '505' 未开通消息撤回
          // e.type === '506' 没有在群组或聊天室白名单
          // e.type === '503' 未知错误
          // this.spinning = false
        },
      })
    },
    /**
     * 获取3个月前的历史消息
     */
    async getOldHistoryMessage(that) {
      // 如果一条值都没有, 直接获取我们存储的历史记录

      if (
        this.msgList.contact &&
        this.currentSession.id &&
        this.msgList.contact[this.currentSession.id] &&
        this.msgList.contact[this.currentSession.id][0]
      ) {
        if (this.msgList.contact[this.currentSession.id][0].current) {
          this.oldHistoryCurrent = this.msgList.contact[this.currentSession.id][0].current + 1
        }
      }

      const { code, data } = await getChatHistory({
        size: 20,
        toMemberCode: this.otherUserInfo.huanxinId || this.otherUserInfo.mchMemberHuanxinId,
        current: this.oldHistoryCurrent,
        contentType: undefined,
        startTime: '2000-01-01',
        endTime: this.oldHistoryMsgEndTime,
      })

      this.isShowLoading = false

      if (code !== 0 || !data) {
        return
      }

      if (this.oldHistoryCurrent >= data.pages) {
        this.isGetAllData = true
      } else {
        this.isGetAllData = false
      }

      let addMessage = []

      data.records.map((item) => {
        if (this.typeComparisonTable[JSON.parse(item.bodies)[0]?.type]) {
          const addMessageItem = {
            contentsType: this.typeComparisonTable[JSON.parse(item.bodies)[0].type],
            data: JSON.parse(item.bodies)[0].msg,
            filename: JSON.parse(item.bodies)[0].filename,
            error: false,
            errorCode: 0,
            errorText: '',
            ext: JSON.parse(item.ext)[0],
            from: item.fromUserId,
            id: item.msgId,
            message_type: item.chatType,
            msgConfig: null,
            sourceMsg: item.msg,
            time: item.timeStamp,
            to: item.toUserId,
            type: item.chatType,
            current: this.oldHistoryCurrent,
          }

          if (JSON.parse(item.bodies)[0].url) {
            addMessageItem.url = JSON.parse(item.bodies)[0].url
          }

          addMessage.push(addMessageItem)
        }
      })

      addMessage = addMessage.reverse()
      console.log('getOldHistoryMessage', data, addMessage)

      this.$store.commit('chat/ADD_HISTORY_MESSAGE', addMessage)

      this.oldHistoryCurrent++
    },
  },
}
</script>

<style lang="scss" scoped>
.messageBox {
  height: 500px;
  display: flex;
  flex-direction: column;
  background: #f8f8f8;

  > .messageItem:nth-of-type(1) {
    box-shadow: inset 0px 12px 10px -15px rgb(0 0 0 / 30%);
  }
}

.message {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 500px;
  background: rgba(248, 248, 248, 1);

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  // .loading {
  //   position: relative;
  //   width: 40px;
  //   left: 50%;
  //   transform: translate(-50%, 0);
  // }

  /*定义滚动条轨道 内阴影+圆角*/
  &::-webkit-scrollbar-track {
    background-color: #eee;
  }

  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #ccc;
  }

  > .messageItem {
    margin: 5px 20px 5px;

    //时间
    > p {
      position: relative;
      left: 50%;
      transform: translate(-50%, 0);
      align-self: center;
      padding: 0 18px;
      font-size: 12px;
      color: #999;
      border-radius: 2px;
      // background-color: #dcdcdc;
      margin: 5px 0px;
      display: inline-block;
      font-weight: bold;
    }

    ::v-deep .msg {
      display: flex;
      align-items: center;
      flex-direction: row;

      .file {
        width: 230px;
        height: 80px;
        border-radius: 6px;
        background-color: white;
        border: 1px solid #f1f1f1;
        box-sizing: border-box;
        display: flex;

        & > div {
          height: 100%;
        }

        .fileInfoBox {
          flex: 1;
          padding: 10px;
          padding-right: 0;
          overflow: hidden;

          .fileNameBox {
            font-weight: 500;
            color: black;
            width: 100%;
            max-height: 40px;
            overflow: hidden;

            /*将对象作为弹性伸缩盒子模型显示*/
            display: -webkit-box;
            /*设置子元素排列方式*/
            -webkit-box-orient: vertical;
            /*设置显示的行数,多出的部分会显示为...*/
            -webkit-line-clamp: 2;
          }

          .fileSize {
            font-size: 12px;
          }
        }

        .fileImgBox {
          width: 70px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &:hover {
          background-color: #fdfdfd;
          cursor: pointer;
        }
      }

      .avatar {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        flex-shrink: 0;
        border: 0;
        border-radius: 6px;
      }

      .voice {
        height: 30px;
        max-width: 340px;
        background: #fff;
        border-radius: 0 8px 8px 8px;
      }

      .text {
        min-height: 30px;
        max-width: 340px;
        font-size: 14px;
        text-align: left;
        // word-break: break-all;
        background: #fff;
        border-radius: 0 8px 8px 8px;
        line-height: 1.4;
        word-break: break-word;

        p {
          padding: 4px 10px;
          font-size: 16px;
          margin: 0;

          a {
            color: black !important;
          }
        }
      }
    }

    ::v-deep .self {
      flex-direction: row-reverse;

      .messageOperatIconBox {
        order: 0;
        margin-right: 10px;
        margin-left: 0;
      }

      .text {
        color: #fff !important;
        background: rgba(255, 102, 0, 0.9);
        border-radius: 8px 0 8px 8px;

        ::selection {
          background: #b5d8fe;
          color: #fef7f1;
        }
      }

      .transform {
        span {
          color: #fff;
        }
      }

      img {
        margin-right: 0px;
        margin-left: 10px;
      }

      a {
        color: #ffe966 !important;
      }

      .voice {
        color: #fff;
        background: rgba(255, 102, 0, 0.9);
        border-radius: 8px 0 8px 8px;
      }
    }
  }
}
</style>
